import { request } from './request'

export const getVersion = () => {
  return m.request({
    url: process.env.API_URL + 'version',
    method: 'GET'
  })
}

export const getAvailableLanguages = () => {
  return request({
    url: 'languages',
    method: 'GET'
  })
    .then(languages => {
      return languages.map(l => {
        return {
          label: l.name,
          value: l.id
        }
      })
    })
}

export const getCountries = () => {
  return request({
    url: 'countries',
    method: 'GET'
  })
    .then(countries => {
      return countries.map(c => {
        return {
          label: c.name,
          value: c.code
        }
      })
    })
}

export const getCurrencies = () => {
  return request({
    url: 'currencies',
    method: 'GET'
  }).then(currencies => {
    return currencies.map(c => {
      return {
        label: c.name,
        value: c.id
      }
    })
  })
}

export const getVenueStatuses = () => {
  return request({
    url: 'core/statuses',
    method: 'GET'
  }).then(statuses => {
    return statuses.map(s => {
      return {
        label: s.name,
        value: s.id
      }
    })
  })
}

export const getVenueGroups = () => {
  return request({
    url: 'venues/groups?pagesize=999'
  })
    .then(vg => {
      return vg.data.map(v => ({
        label: v.name,
        value: v.id
      }))
    })
}

export const getClientStatuses = () => {
  return request({
    url: 'core/statuses'
  })
    .then(cs => {
      return cs.map(s => ({
        label: s.name,
        value: s.id
      }))
    })
}

export const getDepartmentStatuses = () => {
  return request({
    url: 'core/statuses'
  })
    .then(ds => {
      return ds.map(s => ({
        label: s.name,
        value: s.id
      }))
    })
}

export const getEmailMessages = params => {
  return request({
    url: 'emailmessages',
    params: {
      pagesize: 25,
      ...params
    },
    method: 'GET'
  })
}

export const cancelEmailMessage = (id) => {
  return request({
    url: `emailmessages/${id}/cancel`,
    method: 'PUT'
  })
}
export const deleteEmailMessage = (id) => {
  return request({
    url: `emailmessages/${id}`,
    method: 'DELETE'
  })
}

export const getEmailMessage = (id) => {
  return request({
    url: `emailmessages/${id}`,
    method: 'GET'
  })
}

export const getEmailThread = (id) => {
  return request({
    url: `emailmessages/${id}/thread`,
    method: 'GET'
  })
}

export const replyToEmailMessage = (id, reply) => {
  return request({
    url: `emailmessages/${id}/reply`,
    method: 'POST',
    body: reply
  })
}

export const getEmailReplyOptions = (id) => {
  return request({
    url: `emailmessages/${id}/reply-options`,
    method: 'GET'
  })
}

export const markEmailMessageUnread = (id) => {
  return request({
    url: `emailmessages/${id}/unread`,
    method: 'PUT'
  })
}

export const assignEmailThread = (id, userId) => {
  return request({
    url: `emailmessages/${id}/thread/assign`,
    method: 'PUT',
    body: { userId }
  })
}

export const downloadEmailAttachment = (id, attachment) => {
  return request({
    url: `emailmessages/${id}/attachments/${attachment.id}`,
    method: 'GET',
    responseType: 'blob',
    extract (val) {
      return val.response
    }
  })
    .then(res => {
      const anchor = document.createElement('a')
      anchor.download = attachment.filename
      anchor.href = window.URL.createObjectURL(res)
      anchor.click()
    })
}

export const setEmailThreadComplete = (id, isComplete) => {
  return request({
    url: `emailmessages/${id}/thread/complete`,
    method: 'PUT',
    body: { isComplete }
  })
}

export const getEmailCounts = () => {
  return request({
    url: 'emailmessages/counts',
    method: 'GET'
  })
}

export const markEmailMessageRead = (id) => {
  return request({
    url: `emailmessages/${id}/read`,
    method: 'PUT'
  })
}
